module.exports = __webpack_public_path__ + "static/media/dark_en.d57328fe.svg";